<template lang="pug">
  v-row.fill-height.instructions
    v-col(cols=12).sdo-card.fill-column.instructions__container
      list-view-module.py-5(
        select-first
      )
</template>

<script>
import ListViewModule from '../components/InstructionList.vue';

export default {
  components: {
    ListViewModule,
  },
};
</script>

<style lang="scss" scoped>
.instructions {
  max-height: 80vh;

  &__container {
    height: 100%;
  }
}
</style>
